<template>
    <div>
        <el-row>
            <el-col style="margin: 20px 0px 0px 10px;text-align: left">
                <el-form size="small" :inline="true" :model="searchForm" ref="searchForm">
                    <el-form-item label="机型简称：">
                        <el-input placeholder="请输入关键字" v-model="searchForm.NAME" clearable
                            @keyup.enter.native="handlePagerChange(1)" style="width: 150px;"></el-input>
                    </el-form-item>
                    <el-form-item label="扫码筛查：">
                        <el-input placeholder="请输入关键字" v-model="searchForm.SNNAME" clearable
                            @keyup.enter.native="handlePagerChange(1)" style="width: 150px;"></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" size="small" id="search" @click="handlePagerChange(1)"
                            ref="searchBtn">刷新页面</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>

        <el-row>
            <el-col>
                <el-table :data="tableData" @sort-change="handleSortChange" size="mini"
                    :header-cell-class-name="handleHeaderCellClass" border stripe highlight-current-row>
                    <el-table-column type="index" label="序号" align="center" width="50" min-width="30"></el-table-column>
                    <el-table-column prop="typeDesignation" sortable label="机型名称" align="center"
                        min-width="130"></el-table-column>
                    <el-table-column prop="memory" sortable label="内存" align="center" min-width="70"></el-table-column>
                    <el-table-column prop="phoneColor" sortable label="手机颜色" align="center"
                        min-width="100"></el-table-column>
                    <el-table-column prop="batteryHealth" sortable label="电池健康程度" align="center"
                        min-width="120"></el-table-column>
                    <el-table-column prop="qualfity" sortable label="成色" align="center"
                        min-width="80"></el-table-column>
                    <el-table-column prop="phoneClassify" sortable label="手机分类" align="center"
                        min-width="100"></el-table-column>

                    <el-table-column prop="noInterestFreeMoney" label="目前定价(无免息)" align="center" min-width="120">
                        <template slot-scope="scope">
                            {{ scope.row.noInterestFreeMoney }}
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="threeMonthInterestFreeMoney" label="目前定价(3期免息)" align="center" min-width="120">
                    <template slot-scope="scope">
                    {{ scope.row.threeMonthInterestFreeMoney}}
                    </template>
                </el-table-column>
                <el-table-column prop="sixMonthInterestFreeMoney" label="目前定价(6期免息)" align="center" min-width="120">
                    <template slot-scope="scope">
                    {{ scope.row.sixMonthInterestFreeMoney}}
                    </template>
                </el-table-column>
                <el-table-column prop="twelveMonthInterestFreeMoney" label="目前定价(12期免息)" align="center" min-width="135">
                    <template slot-scope="scope">
                    {{ scope.row.twelveMonthInterestFreeMoney}}
                    </template>
                </el-table-column> -->
                    <el-table-column prop="frontViewRemark" label="手机正面图备注" align="center"
                        min-width="120"></el-table-column>
                    <el-table-column prop="backViewRemark" label="手机背面图备注" align="center"
                        min-width="120"></el-table-column>
                    <el-table-column prop="leftSideRemark" label="手机左侧图备注" align="center"
                        min-width="120"></el-table-column>
                    <el-table-column prop="rightSideRemark" label="手机右侧图备注" align="center"
                        min-width="120"></el-table-column>
                    <el-table-column prop="topViewRemark" label="手机顶部图备注" align="center"
                        min-width="120"></el-table-column>
                    <el-table-column prop="bottomPortRemark" label="手机尾插图备注" align="center"
                        min-width="120"></el-table-column>
                    <el-table-column fixed="right" label="操作" align="center" min-width="200px">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="detail(scope.row)" style="color: #ebb563">详细信息
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col style="text-align: right;">
                <el-pagination @current-change="handlePagerChange" :current-page.sync="currentPage"
                    :page-size="pageSize" :total="totalCount" layout="total, prev, pager, next, jumper"></el-pagination>
            </el-col>
        </el-row>
        <el-dialog @close="handleClose" :title="phoneDetailTitle" center :visible.sync="phoneDetailVisible" width="70%"
            :close-on-click-modal="false">
            <el-form size="small" :model="phoneDetailForm" ref="phoneDetailForm" :label-width="formLabelWidth">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="手机正面图备注：" prop="frontViewRemark">
                            <el-input v-model="phoneDetailForm.frontViewRemark"
                                :class="{ customColor: isFrontCustomColor }">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="手机左侧图备注：" prop="leftSideRemark"
                            :class="{ customColor: isLeftCustomColor }">
                            <el-input v-model="phoneDetailForm.leftSideRemark">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="手机顶部图备注：" prop="topViewRemark" :class="{ customColor: isTopCustomColor }">
                            <el-input v-model="phoneDetailForm.topViewRemark">
                            </el-input>
                        </el-form-item>

                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机背面图备注：" prop="backViewRemark" :class="{ customColor: isCustomColor }">
                            <el-input v-model="phoneDetailForm.backViewRemark">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="手机右侧图备注：" prop="rightSideRemark"
                            :class="{ customColor: isRightCustomColor }">
                            <el-input v-model="phoneDetailForm.rightSideRemark">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="手机尾插图备注：" prop="bottomPortRemark"
                            :class="{ customColor: isBottomCustomColor }">
                            <el-input v-model="phoneDetailForm.bottomPortRemark">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="机型名称：" prop="typeDesignation">
                            <el-input v-model="phoneDetailForm.typeDesignation">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="内存：" prop="memory">
                            <el-input v-model="phoneDetailForm.memory">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="手机颜色：" prop="phoneColor">
                            <el-input v-model="phoneDetailForm.phoneColor">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="电池健康程度：" prop="batteryHealth">
                            <el-input v-model="phoneDetailForm.batteryHealth">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="成色：" prop="qualfity">
                            <el-input v-model="phoneDetailForm.qualfity">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="手机分类：" prop="phoneClassify">
                            <el-input v-model="phoneDetailForm.phoneClassify">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="定价(无免息)：" prop="noInterestFreeMoney">
                            <el-input v-model="phoneDetailForm.noInterestFreeMoney">
                            </el-input>
                        </el-form-item>
                        <!-- <el-form-item label="定价(6期免息)：" prop="sixMonthInterestFreeMoney">
                            <el-input v-model="phoneDetailForm.sixMonthInterestFreeMoney">
                            </el-input>
                        </el-form-item> -->
                    </el-col>
                    <!-- <el-col :span="12">
                        <el-form-item label="定价(3期免息)：" prop="threeMonthInterestFreeMoney">
                            <el-input v-model="phoneDetailForm.threeMonthInterestFreeMoney">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="定价(12期免息)：" prop="twelveMonthInterestFreeMoney">
                            <el-input v-model="phoneDetailForm.twelveMonthInterestFreeMoney">
                            </el-input>
                        </el-form-item>
                    </el-col> -->
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <!-- <el-button size="small" @click="handleClose" type="warning" plain
                >取 消</el-button
                > -->
            </div>
        </el-dialog>
    </div>
</template>
<script>
import axios from "axios";
export default {
    data() {
        return {
            textColor: 'black', // 默认颜色
            tableData: [],
            inventoryList: [],

            phoneDetailTitle: "手机详细信息",
            phoneDetailVisible: false,
            phoneDetailForm: {},
            formLabelWidth: "140px",

            currentPage: 1,
            pageSize: 20,
            totalCount: 0,
            searchForm: {},
            // 存储排序状态
            sortProp: null,
            sortOrder: null,
            currentSort: {
                prop: '',
                order: ''
            },
            key1: 'queId',
            value1: null,
            key2: 'isAscend',
            value2: null,
            sorts: [],
            sortArray: [],
            isFrontCustomColor: false,
            isLeftCustomColor: false,
            isRightCustomColor: false,
            isTopCustomColor: false,
            isBottomCustomColor: false,
            isCustomColor: false,
            userId: "1940693",
            queIdphoneName: "",
            queIdphoneColor: "",
            queIdphoneMemory: "",
            queIdphoneElectricityList: "",
            queIdphoneOld: "",
            phoneClassify: "",
        }
    },
    mounted() {
        this.queryListAppFieldByUserId();
        this.login();
    },
    methods: {
        login() {
            const currentUrl = window.location.toString();
            const urlObject = new URL(currentUrl);
            const searchParams = new URLSearchParams(urlObject.search);
            const userId = searchParams.get("qfExtUserId");
            if (userId != null || userId != undefined) {
                this.userId = userId;
            }
            console.log("userid:", this.userId);
            // 创建一个新的 Axios 实例专用于 /orderListApi 请求
            const loginApiInstance = axios.create({
                baseURL: "/loginApi",
            });
            //使用FormData对象发送POST请求
            loginApiInstance
                .get("monkeyshop/user/login/" + this.userId)
                .then((res) => {
                    // this.tableData = res.data.data;
                    if (res.data.code == 200) {
                        this.queryInventoryList()
                    } else {
                        alert(res.data.msg);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        reClearTextColor() {
            this.isFrontCustomColor = false,
                this.isLeftCustomColor = false,
                this.isRightCustomColor = false,
                this.isTopCustomColor = false,
                this.isBottomCustomColor = false,
                this.isCustomColor = false
        },
        changeColor() {
            console.log('gaibianle')
            if (this.phoneDetailForm.frontViewRemark !== '完好') {
                this.isFrontCustomColor = true
            }
            if (this.phoneDetailForm.leftSideRemark !== '完好') {
                this.isLeftCustomColor = true
            }
            if (this.phoneDetailForm.topViewRemark !== '完好') {
                this.isTopCustomColor = true
            }
            if (this.phoneDetailForm.backViewRemark !== '完好') {
                this.isCustomColor = true
            }
            if (this.phoneDetailForm.bottomPortRemark !== '完好') {
                this.isBottomCustomColor = true
            }
            if (this.phoneDetailForm.rightSideRemark !== '完好') {
                this.isRightCustomColor = true
            }
        },
        detail(row) {
            this.phoneDetailVisible = true
            this.phoneDetailForm = { ...row }
            this.changeColor()
            console.log(this.phoneDetailForm, 'phoneDetailForm')
        },
        handleClose() {
            this.phoneDetailVisible = false
            this.searchForm.SNNAME = ''
            this.reClearTextColor()
        },
        handlePagerChange(val) {
            this.currentPage = val;
            this.queryInventoryList();
        },
        // 保留所有排序过的箭头样式
        handleHeaderCellClass({ row, column, rowIndex, columnIndex }) {
            const sortArray = this.sortArray;
            for (let i = 0; i < sortArray.length; i++) {
                if (column.property === sortArray[i].prop) {
                    column.order = sortArray[i].order;
                }
            }
        },
        handleSortChange({ prop, order }) {
            // 更新排序状态
            this.sortProp = prop;
            this.sortOrder = order;
            console.log(prop, 'prop', order, 'order', 'sortchange')
            if (prop == 'qualfity' && order !== null) {
                this.value1 = this.queIdphoneOld
                if (order == 'ascending') {
                    this.value2 = true
                } else {
                    this.value2 = false
                }
                let obj = {
                    [this.key1]: this.value1,
                    [this.key2]: this.value2
                };
                this.sorts.push(obj)
                console.log(this.sorts, 'this.sorts')
            }
            if (prop == 'phoneClassify' && order !== null) {
                this.value1 = this.phoneClassify
                if (order == 'ascending') {
                    this.value2 = true
                } else {
                    this.value2 = false
                }
                let obj = {
                    [this.key1]: this.value1,
                    [this.key2]: this.value2
                };
                this.sorts.push(obj)
                console.log(this.sorts, 'this.sorts')
            }
            if (prop == 'typeDesignation' && order !== null) {
                this.value1 = this.queIdphoneName
                if (order == 'ascending') {
                    this.value2 = true
                } else {
                    this.value2 = false
                }
                let obj = {
                    [this.key1]: this.value1,
                    [this.key2]: this.value2
                };
                this.sorts.push(obj)
                console.log(this.sorts, 'this.sorts')
            }
            if (prop == 'phoneColor' && order !== null) {
                this.value1 = this.queIdphoneColor
                if (order == 'ascending') {
                    this.value2 = true
                } else {
                    this.value2 = false
                }
                let obj = {
                    [this.key1]: this.value1,
                    [this.key2]: this.value2
                };
                this.sorts.push(obj)
                console.log(this.sorts, 'this.sorts')
            }
            if (prop == 'memory' && order !== null) {
                this.value1 = this.queIdphoneMemory
                if (order == 'ascending') {
                    this.value2 = true
                } else {
                    this.value2 = false
                }
                let obj = {
                    [this.key1]: this.value1,
                    [this.key2]: this.value2
                };
                this.sorts.push(obj)
                console.log(this.sorts, 'this.sorts')
            }
            if (prop == 'batteryHealth' && order !== null) {
                this.value1 = this.queIdphoneElectricityList
                if (order == 'ascending') {
                    this.value2 = true
                } else {
                    this.value2 = false
                }
                let obj = {
                    [this.key1]: this.value1,
                    [this.key2]: this.value2
                };
                this.sorts.push(obj)
                console.log(this.sorts, 'this.sorts')
            }
            console.log(this.sorts.length, '最终sorts')
            // 发起后端请求，并带上排序参数
            this.queryInventoryList();
        },
        queryInventoryList() {
            const inventoryListApiInstance = axios.create({
                baseURL: "/inventoryApi",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            let params = {
                pageSize: this.pageSize,
                pageNum: this.currentPage - 1,
                userId: this.userId,
                sorts: [
                    { "queId": this.queIdphoneName, "isAscend": false },
                    { "queId": this.queIdphoneColor, "isAscend": false },
                    { "queId": this.queIdphoneMemory, "isAscend": false },
                    { "queId": this.queIdphoneElectricityList, "isAscend": false },
                    { "queId": this.queIdphoneOld, "isAscend": false },
                ]
            }
            if (this.sorts.length >= 1) {
                params.sorts = this.sorts
            }
            if (this.searchForm.NAME) {
                params.typeDesignation = this.searchForm.NAME;
                params.sorts = [
                    { "queId": this.queIdphoneName, "isAscend": true },
                    { "queId": this.queIdphoneColor, "isAscend": true },
                    { "queId": this.queIdphoneMemory, "isAscend": false },
                    { "queId": this.queIdphoneElectricityList, "isAscend": false },
                    { "queId": this.queIdphoneOld, "isAscend": false },
                ]
            }
            if (this.searchForm.SNNAME) {
                params.imei = this.searchForm.SNNAME;
            }
            console.log(params, 'params')
            //使用FormData对象发送POST请求
            inventoryListApiInstance.post("monkeyshop/inventory/getInventoryList", params)
                .then((res) => {
                    console.log(res, "res");
                    this.tableData = res.data.data.data.getList;
                    this.totalCount = res.data.data.data.resultAmount;
                    if (this.searchForm.SNNAME) {
                        console.log(res.data.data.data.getInventoryListArrayVO, 'rrres')
                        // that.$set(that.phoneDetailForm,'qualfity',res.data.data.inventoryList.qualfity)
                        this.phoneDetailForm.qualfity = res.data.data.inventoryList[0].qualfity
                        this.phoneDetailForm.phoneClassify = res.data.data.inventoryList[0].phoneClassify
                        this.phoneDetailForm.typeDesignation = res.data.data.inventoryList[0].typeDesignation
                        this.phoneDetailForm.phoneColor = res.data.data.inventoryList[0].phoneColor
                        this.phoneDetailForm.memory = res.data.data.inventoryList[0].memory
                        this.phoneDetailForm.batteryHealth = res.data.data.inventoryList[0].batteryHealth
                        this.phoneDetailForm.noInterestFreeMoney = res.data.data.inventoryList[0].noInterestFreeMoney
                        this.phoneDetailForm.threeMonthInterestFreeMoney = res.data.data.inventoryList[0].threeMonthInterestFreeMoney
                        this.phoneDetailForm.sixMonthInterestFreeMoney = res.data.data.inventoryList[0].sixMonthInterestFreeMoney
                        this.phoneDetailForm.twelveMonthInterestFreeMoney = res.data.data.inventoryList[0].twelveMonthInterestFreeMoney
                        this.phoneDetailForm.frontViewRemark = res.data.data.inventoryList[0].frontViewRemark
                        this.phoneDetailForm.backViewRemark = res.data.data.inventoryList[0].backViewRemark
                        this.phoneDetailForm.leftSideRemark = res.data.data.inventoryList[0].leftSideRemark
                        this.phoneDetailForm.rightSideRemark = res.data.data.inventoryList[0].rightSideRemark
                        this.phoneDetailForm.topViewRemark = res.data.data.inventoryList[0].topViewRemark
                        this.phoneDetailForm.bottomPortRemark = res.data.data.inventoryList[0].bottomPortRemark
                        console.log(this.phoneDetailForm, 'phoneDetailForm')
                        this.changeColor()
                        this.phoneDetailVisible = true
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        queryListAppFieldByUserId() {
            // 创建一个新的 Axios 实例专用于 /orderListApi 请求
            const orderListApiInstance = axios.create({
                baseURL: "/inventoryApi",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            let params = {
                userId: this.userId,
                appName: "手机入库"
            };
            //使用FormData对象发送POST请求
            orderListApiInstance
                .post("monkeyshop/user/listAppFieldByUserId", params)
                .then((res) => {
                    console.log(res, "res");
                    console.log(res.data.data);
                    const map = res.data.data.reduce((acc, item) => {
                        acc[item.fieldTitle] = item;
                        return acc;
                    }, {});
                    console.log("map", map);
                    this.queIdphoneName = map["机型名称"].fieldQueId;
                    this.queIdphoneColor = map["手机颜色"].fieldQueId;
                    this.queIdphoneMemory = map["内存"].fieldQueId;
                    this.queIdphoneElectricityList = map["电池健康程度"].fieldQueId;
                    this.queIdphoneOld = map["成色"].fieldQueId;
                    this.phoneClassify = map["手机分类"].fieldQueId;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
    }

}
</script>
<style>
.el-button--primary {
    color: #fff;
    background-color: #fb9337;
    border-color: #fb9337;
}

.customColor input {
    color: red !important;
    /* 使用!important确保覆盖 */
}
</style>


// WEBPACK FOOTER //
// src/views/anchorView.vue